export default {
	state: () => ({
        COMP_NO: null,
		TOP_MENU_ID: ""
	}),
	mutations: {
        setCompNo(state, value) {
            state.COMP_NO = value
        },
		setTopMenuId(state, value) {
			state.TOP_MENU_ID = value
		},
	},
	getters: {
        COMP_NO: (state) => {
            return state.COMP_NO
        },
		TOP_MENU_ID : (state) => {
			return state.TOP_MENU_ID
		},
	}
 }